import { createContext, type ReactNode } from 'react';

type KeepMountedContextProps = {
  getPortalElement: (
    id: string,
    children: ReactNode,
  ) => HTMLElement | undefined;
};

/** @internal */
export const KeepMountedContext = createContext<KeepMountedContextProps>({
  getPortalElement: () => undefined,
});
KeepMountedContext.displayName = 'KeepMountextContext';
